<template>
    <div class="inspectionRecord-box">
        <div class="inspectionRecord-top">
            <h3>{{infoData.tourDate}}</h3>
            <div class="worker-box">
                <img class="worker-img" src="../../assets/img/user.png"/>
                <div class="worker-wrap">
                   <p class="name">{{infoData.uname}}</p>
                   <p class="time">{{infoData.tourBg}}-{{infoData.tourEd}}</p>
                </div>
                <span class="frequency">第{{infoData.tourNum}}次巡检</span>
            </div>
        </div>
        <ul class="information-box">
            <li>
                <span>巡棚鸡舍：</span>
                <span>{{infoData.tourShed}}</span>
            </li>
            <li>
                <span>日龄：</span>
                <span>{{infoData.tourAge}}</span>
            </li>
            <li>
                <span>温控设置：</span>
                <span>{{infoData.tourWarm}}</span>
            </li>
            <li>
                <span>风机使用：</span>
                <span>{{infoData.tourFan}}</span>
            </li>
            <li>
                <span>水料情况：</span>
                <span>{{infoData.tourWater}}</span>
            </li>
            <li>
                <span>鸡群状态：</span>
                <span>{{infoData.tourChickens}}</span>
            </li>
            <li>
                <span>粪便情况：</span>
                <span>{{infoData.tourFeces}}</span>
            </li>
            <li>
                <span>呼吸道情况：</span>
                <span>{{infoData.tourBreathtract}}</span>
            </li>
            <li>
                <span>死淘情况：</span>
                <span>{{infoData.tourDeadamoy}}</span>
            </li>
            <li>
                <span>其他情况：</span>
                <span>{{infoData.tourOther}}</span>
            </li>
        </ul>
        <div class="images-box">
            <img v-for="(i,index) in infoData.picUrl" :key="index" :src="i"/>
        </div>
    </div>
</template>
<script>
import {tourinfo} from '@/api/resetApi.js';
import { wxshare } from '@/utils/utils.js'
export default {
    data () {
        return {
            infoData:{}
        }
    },
    created(){
        document.title = '禽智养殖'
        if(this.$route.query.id){
            this.info()
        }
    },
    methods:{
        async info() {
            let res = await tourinfo({ id: this.$route.query.id });
                if (res.data.code == 200) {
                   this.infoData = res.data.data
                   let title = `巡检记录：第${this.infoData.tourNum}次巡检`
                   let desc = `${this.infoData.tourDate} ${this.infoData.tourBg} - ${this.infoData.tourEd} ${this.infoData.uname}`
                   wxshare('',title,desc,window.location.href);
                }
        },
    }
}
</script>
<style scoped lang="scss">
.inspectionRecord-box{
    padding: 0 3.73vw;
}
.inspectionRecord-top{
    border-bottom: 1px solid #f5f5f5;
    border-top: 1px solid #f5f5f5;
    padding-bottom: 2.13vw;
    h3{
        font-size: 4.27vw;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 1;
        padding: 4.8vw 0;
    }
    .worker-box{
        display: flex;
        align-items: center;
        .worker-img{
            width: 8.53vw;
            height: 8.53vw;
            border-radius: 50%;
            margin-right: 1.6vw;
        }
        .worker-wrap{
            flex: 1;
        }
        .name{
            font-size: 3.73vw;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: #181818;
            line-height: 5.33vw;
        }
        .time{
            font-size: 3.2vw;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 4.8vw;
        }
        .frequency{
            font-size: 3.73vw;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 4.8vw;
        }
    }
}
.information-box{
    padding-top: 2.57vw;
    li{
        font-size: 3.73vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #717171;
        line-height: 1.5;
        padding: 1.87vw 0;
    }
}
.images-box{
    padding: 4.8vw 0;
    img{
        width: 100%;
    }
}
</style>